var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"music",attrs:{"id":"music"},on:{"click":_vm.toggleMusic}},[_c('div',{staticClass:"note",class:_vm.isPlay ? 'rotating on' : 'off'}),_vm._v(" "),_c('audio',{attrs:{"src":_vm.musicURL,"id":"myMusic","preload":"preload","loop":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07add748","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/musicplayer/music-player.vue
// module id = null
// module chunks = 